import * as React from "react";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {Modal} from "react-bootstrap";
import {renderISOMetadata, RenderISOMetadataResult} from "@hexagon/apollo-iso-metadata";
import {getLanguageAndLocale} from "../common/intl/intl";
import {STUDIO_API_PATH} from "../paths";

const mapDispatchToProps = (dispatch, ownProps) => ({});

interface ISOMetadataPopupProps {
    dataId: string;
    onHide: () => void;
}

class ISOMetadataPopupComponent extends React.Component<ISOMetadataPopupProps & InjectedIntlProps> {
    private renderISOMetadataResult: RenderISOMetadataResult;

    render() {
        return (
            <Modal className="isoMetadataPopup" show={true} onHide={this.hide}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>
                        <FormattedMessage id="studio.data.ISO-Metadata.title" defaultMessage="ISO Metadata"/>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{maxHeight: "calc(100vh - 200px)", overflowY: "auto"}}>
                    <div className="isoMetadataBodyContent" ref={this.init}></div>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        );
    }

    private init = (element) => {
        const {dataId} = this.props;
        const locale = getLanguageAndLocale().locale;

        if (!element) {
            return;
        }

        this.renderISOMetadataResult = renderISOMetadata({
            element,
            staticFilesPath: "apollo-iso-metadata-static",
            apolloApiBaseUrl: STUDIO_API_PATH,
            id: dataId,
            locale,
        });

    }

    private hide = () => {
        this.renderISOMetadataResult.dispose();
        this.props.onHide();
    }
}

export const ISOMetadataPopup = injectIntl(connect(null, mapDispatchToProps)(ISOMetadataPopupComponent));